module.exports = __webpack_public_path__ + "public/images/logo-black.9a8ddf36760879bf184d2c2ae53c05dc.svg";